import { MAILING_RECIPIENT_API } from 'shared/components/dashboard-mail-editor/api/email-api'
import { EmailId } from 'shared/components/dashboard-mail-editor/types/email-interface'
import { EmailWithRecipientApiInterface } from 'shared/components/dashboard-mail-editor/types/email-with-recipient'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import { useOnceTrue } from 'shared/hooks/use-once-true'
import useUser from 'shared/hooks/use-user'
import useSWR from 'swr'

export function useEmailWithRecipient(mailingId: EmailId, shouldFetch = true) {
  const { user } = useUser()

  const { fetcher } = useFetch<RequestMethodsEnum.get, EmailWithRecipientApiInterface>({
    method: RequestMethodsEnum.get,
  })

  const allowed = useOnceTrue(!!user && !!shouldFetch)

  return useSWR(() => {
    if (allowed) {
      return `${MAILING_RECIPIENT_API}/${mailingId}`
    }
  }, fetcher)
}
